import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../models'
import ButtonClose from '../../../../../components/UI/Button/IconButton'
import {TableChangeRoomsDetailWrapper} from '../components/Tables/TableChangeRoomsDetail'
import {TableChangeRoomsDocumentsWrapper} from '../components/Tables/TableChangeRoomsDocuments'

const DetailChangeRoomsPanel: FC = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <ButtonClose onClick={handleBack} color='#283897' />
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            {isAllowed('CAMBIOHABITACIONES/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Cambio Habitaciones</Tab>
            )}
            {isAllowed('DOCUMENTO/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Documento</Tab>
            )}
          </TabList>
          {isAllowed('CAMBIOHABITACIONES/ACCESO') && (
            <TabPanel>
              <TableChangeRoomsDetailWrapper />
            </TabPanel>
          )}
          {isAllowed('DOCUMENTO/ACCESO') && (
            <TabPanel>
              <TableChangeRoomsDocumentsWrapper />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  )
}

export {DetailChangeRoomsPanel}
